import { gql } from '@apollo/client';
import _ from 'lodash';
import { applicationStatusTypes } from '../constants/statusConstants';

export const INVITE_TO_MOVE_IN_QUERY = gql`
  query InviteToMoveIn($propertyId: String!, $applicationId: String!) {
    property(id: $propertyId) {
      id
      contactName
      street
      application(id: $applicationId) {
        id
        applicants {
          id
          isPrimaryApplicant
          contactInfo {
            firstName
            name
          }
          status
          submittedDate
        }
        status
        acceptedDate
        invitedToMoveInDate
      }
      rentGuarantee {
        id
        isRentGuaranteeEnabled
        isIncomeToRentEligible(applicationId: $applicationId)
        isIncomeToRentVerified(applicationId: $applicationId)
        legalDisclaimerContent {
          disclaimers {
            header
            description {
              text
              url
              stylings
            }
          }
        }
      }
    }
  }
`;

export const INVITE_TO_MOVE_IN_MUTATION = gql`
  mutation InviteToMoveIn($propertyId: String!, $applicationId: String!, $emailText: String!) {
    inviteToMoveIn(propertyId: $propertyId, applicationId: $applicationId, emailText: $emailText) {
      id
      status
    }
  }
`;

export const ACCEPT_APPLICATION_MUTATION = gql`
  mutation AcceptApplication(
    $propertyId: String!
    $applicationId: String!
    $applicantId: String!
    $zgAuthZone: String!
    $emailText: String!
  ) {
    acceptApplication(
      propertyId: $propertyId
      applicationId: $applicationId
      applicantId: $applicantId
      zgAuthZone: $zgAuthZone
      emailText: $emailText
    ) {
      id
      status
    }
  }
`;

export function getInvitationInfo(data) {
  return {
    applicants: _.get(data, `property.application.applicants`, []),
    contactName: _.get(data, `property.contactName`),
    street: _.get(data, `property.street`),
  };
}

export function getIsAcceptedOrInvitedToMoveIn(data) {
  const applicationStatus =
    // From query.
    _.get(data, 'property.application.status') ||
    // From inviteToMoveIn mutation.
    _.get(data, 'inviteToMoveIn.status') ||
    // From acceptApplication mutation.
    _.get(data, 'acceptApplication.status');

  switch (applicationStatus) {
    case applicationStatusTypes.ACCEPTED.id:
    case applicationStatusTypes.INVITED_TO_MOVE_IN.id:
      return true;
    default:
      return false;
  }
}

export function getIsDeclined(data) {
  const applicationStatus =
    // From query.
    _.get(data, 'property.application.status') ||
    // From inviteToMoveIn mutation.
    _.get(data, 'inviteToMoveIn.status') ||
    // From acceptApplication mutation.
    _.get(data, 'acceptApplication.status');

  switch (applicationStatus) {
    case applicationStatusTypes.DECLINED.id:
      return true;
    default:
      return false;
  }
}
